import type { IGenericOption } from "@gettactic/api";

export type UserOptionData = IGenericOption & {
  profile_photo_url?: string;
  email?: string;
};

type UserOptionSource = {
  id: string;
  name: string;
  profile_photo_url?: string | null;
  email?: string | null;
};

/** The option shape the user pickers list and the guest chips render. */
export const toUserOption = (user: UserOptionSource): UserOptionData => ({
  value: user.id,
  label: user.name,
  profile_photo_url: user.profile_photo_url ?? "",
  email: user.email ?? undefined
});
